
import {APIEndpoint} from "../../common/constants";
import {getAPIGatewayRequest, getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";


/**
 * This method will return list of remittance created at a particular station
 * @param params
 * @returns {Promise<*>}
 */
export async function getRemittanceList(params) {
    const {stationCode, startDate, endDate} = params;
    const endTime = endDate.valueOf();
    const startTime = startDate.valueOf();
    const requestArgs = {
        stationCode,
        dateRange: {
            startTime,
            endTime
        }
    };

    const apiGatewayRequest = getAPIGatewayRequest(APIEndpoint.GET_REMITTANCE, requestArgs, "POST");
    try {
        return getAPIGatewayDataFromParent(apiGatewayRequest);
    } catch (error) {
        throw error;
    }
}

/**
 * This method will create a new remittance with existing cash at station.
 * @param params
 * @returns {Promise<*>}
 */
export function createRemittanceRequest(params) {
    try {
        const apiGatewayRequest = getAPIGatewayRequest(APIEndpoint.CREATE_DEPOSIT, params, "POST");
        return getAPIGatewayDataFromParent(apiGatewayRequest);
    } catch (error) {
        throw error;
    }
}

/**
 * This method will call API Gateway to create adhoc coin remittance to bank
 * @param params
 * @returns {Promise<*>}
 */
export function submitCoinRemittanceRequest(params) {
    try {
        const apiGatewayRequest = getAPIGatewayRequest(APIEndpoint.SUBMIT_COIN_REMITTANCE, params, "POST")
        return getAPIGatewayDataFromParent(apiGatewayRequest);
    } catch (error) {
        throw error;
    }
}

/**
 * This method will call API Gateway to submit already created remittance to bank
 * @param params
 * @returns {Promise<*>}
 */
export function submitRemittanceRequest(params) {
    try {
        const apiGatewayRequest = getAPIGatewayRequest(APIEndpoint.SUBMIT_REMITTANCE, params, "POST")
        return getAPIGatewayDataFromParent(apiGatewayRequest);
    } catch (error) {
        throw error;
    }
}

/**
 * This method will call API Gateway to update remittance code of an existing remittance
 * @param params
 * @returns {Promise<*>}
 */
export function updateRemittanceRequest(params) {
    try {
        const apiGatewayRequest = getAPIGatewayRequest(APIEndpoint.UPDATE_REMITTANCE, params, "POST");
        return getAPIGatewayDataFromParent(apiGatewayRequest);
    } catch (error) {
        throw error;
    }
}

/**
 * This method will call API Gateway to add station variance for remittance
 * @param params 
 * @returns {Promise<*>}
 */
export async function addStationVarianceForRemittance(params) {
    try {
        const apiGatewayRequest = getAPIGatewayRequest(APIEndpoint.ADD_STATION_VARIANCE_FOR_REMITTANCE, params, "POST");
        return getAPIGatewayDataFromParent(apiGatewayRequest);
    } catch (error) {
        throw error;
    }
}

/**
 * This method will call API Gateway to verify remittance's variance
 * @param params 
 * @returns {Promise<*>}
 */
export function verifyRemittanceV2Request(params) {
    try {
        const apiGatewayRequest = getAPIGatewayRequest(APIEndpoint.VERIFY_REMITTANCE, params, "POST");
        return getAPIGatewayDataFromParent(apiGatewayRequest);
    } catch (error) {
        throw error;
    }
}

/**
 * This method will call API Gateway to submit the remittance code
 * @param params 
 * @returns {Promise<*>}
 */
export function submitRemittanceV2Request(params) {
    try {
        const apiGatewayRequest = getAPIGatewayRequest(APIEndpoint.SUBMIT_REMITTANCE_V2, params, "POST");
        return getAPIGatewayDataFromParent(apiGatewayRequest);
    } catch (error) {
        throw error;
    }
}

/**
 * This method will call API Gateway to reset the remittance
 * @param params 
 * @returns {Promise<*>}
 */
export function resetRemittanceRequest(params) {
    try {
        const apiGatewayRequest = getAPIGatewayRequest(APIEndpoint.RESET_REMITTANCE, params, "POST");
        return getAPIGatewayDataFromParent(apiGatewayRequest);
    } catch (error) {
        throw error;
    }
}


// WEBPACK FOOTER //
// ./src/component/remittance/network/RemittanceAPI.js